module.exports = __webpack_public_path__ + "img/sweet-home-3d.5418c5da.png";